import { ViewOpportunityCompletion } from "./components/ViewOpportunityCompletion";
export default ViewOpportunityCompletion;